export const COMMON_ERRORS = {
    UNAUTHORIZED: { code: "unauthorized", message: "Authentification requise" },
    FORBIDDEN: { code: "forbidden", message: "Accès refusé" },
    NOT_FOUND: { code: "not_found", message: "Ressource introuvable" },
    VALIDATION_ERROR: { code: "validation_error", message: "Données invalides" },
    INTERNAL_ERROR: { code: "internal_error", message: "Erreur interne du serveur" },
};
